import { Grid } from '@design-system';

import { ArtistListStoryblok } from '../types/generated-storyblok';
import { ContentArtist } from './Journals/ContentArtist';

interface ContentBlockArtistsProps {
  blok: ArtistListStoryblok;
}

export const ContentBlockArtists = ({ blok }: ContentBlockArtistsProps) => (
  <Grid className="gap-y-6" columns={4}>
    {blok.artists.map((artistId) => (
      <ContentArtist key={artistId._uid} blok={artistId} variant="card" />
    ))}
  </Grid>
);
